/**
 * © [2023] Conduent, Inc. All rights reserved. Conduent®and Conduent Agile
 * Star®are trademarks of Conduent, Inc. and/or its subsidiaries in the United
 * States and/or other countries.
 */
import MaxLengthNumericEditor from '../../../../../SharedModules/CustomAgGridEditor/inputComponent';
import * as Styles from '../../../../../SharedModules/StyleConstant/StyleConstant';

function amountComparator(amount1, amount2) {
  let amt1 = null;
  let amt2 = null;
  if (amount1 && amount1?.toString()?.includes('$')) {
    amt1 = parseFloat(amount1?.toString().split('$')[1]);
  } else {
    amt1 = amount1;
  }
  if (amount2 && amount2?.toString()?.includes('$')) {
    amt2 = parseFloat(amount2?.toString().split('$')[1]);
  } else {
    amt2 = amount2;
  }
  if (amt1 === null && amt2 === null) {
    return 0;
  }
  if (amt1 === null) {
    return -1;
  }
  if (amt2 === null) {
    return 1;
  }

  return amt1 - amt2;
}
export const TableHeadUnderThrInv = [
  {
    headerName: 'Comments Exists',
    field: 'ccCommentsExist',
    filter: false,
    sortable: false,
    enableMenu: false,
    showCheckboxIcon: true,
    minWidth: Styles.Width_150,
    resizable: true,
    editable: false,
    suppressMenu: false,
    cellEditor: MaxLengthNumericEditor,
    cellRenderer: 'ActionCellRender',
    cellStyle: { 'border-right-color': Styles.BorderColor },
  },
  {
    headerName: 'Manufacturer ID',
    field: 'mfgId',
    editable: false,
    sortable: true,
    minWidth: Styles.Width_180,
    cellEditor: MaxLengthNumericEditor,
    sort: 'asc',
    sortingOrder: ['desc', 'asc'],
    cellStyle: { 'border-right-color': Styles.BorderColor },
    filter: 'agTextColumnFilter',
    filterParams: {
      defaultOption: 'startsWith',
      suppressAndOrCondition: true,
      buttons: ['reset'],
      refreshValuesOnOpen: true,
    },
  },
  {
    headerName: 'Manufacturer Name',
    field: 'mfgName',
    editable: false,
    sortable: true,
    columnSpan: 4,
    minWidth: Styles.Width_270,
    cellEditor: MaxLengthNumericEditor,
    cellRenderer: 'nameRenderMFG',
    cellStyle: { 'border-right-color': Styles.BorderColor },
    sortingOrder: ['desc', 'asc'],
    filter: 'agTextColumnFilter',
    cellClass: 'overrideDefault frr-ellipsis-text-overlap',
    filterParams: {
      defaultOption: 'startsWith',
      suppressAndOrCondition: true,
      buttons: ['reset'],
      refreshValuesOnOpen: true,
    },
  },
  {
    headerName: '',
    field: '',
    removeColumn: true,
    minWidth: 1,
    resizable: false,
    editable: false,
  },
  {
    headerName: '',
    field: '',
    removeColumn: true,
    minWidth: 1,
    resizable: false,
    editable: false,
  },
  {
    headerName: '',
    field: '',
    removeColumn: true,
    minWidth: 1,
    resizable: false,
    editable: false,
  },
  {
    headerName: 'Invoice Handling Code',
    field: 'invoiceHandlingCd',
    editable: false,
    sortable: true,
    minWidth: Styles.Width_200,
    cellEditor: MaxLengthNumericEditor,
    wrapHeaderText: true,
    autoHeaderHeight: true,
    sortingOrder: ['desc', 'asc'],
    cellRenderer: 'InvoiceHandlingCdCellRender',
    showDropDownVal: true,
    dropDownValueCol: 'invoiceHandlingCdValWithLabel',
    cellStyle: { 'border-right-color': Styles.BorderColor },
    filterParams: {
      defaultOption: 'startsWith',
      suppressAndOrCondition: true,
      buttons: ['reset'],
      refreshValuesOnOpen: true,
    },
  },
  {
    headerName: 'Retained Amt',
    field: 'retainedAmount',
    comparator: amountComparator,
    editable: false,
    sortable: true,
    isTextColorRed: true,
    minWidth: Styles.Width_160,
    cellEditor: MaxLengthNumericEditor,
    cellRenderer: 'RetainedAmtCellRender',
    cellStyle: { textAlign: 'right', 'border-right-color': Styles.BorderColor },
    sortingOrder: ['desc', 'asc'],
    // exportZeroesTwo: true,
    filter: 'agTextColumnFilter',
    filterParams: {
      defaultOption: 'startsWith',
      suppressAndOrCondition: true,
      buttons: ['reset'],
      refreshValuesOnOpen: true,
    },
  },
  {
    headerName: 'Current Invoiced Amt',
    field: 'totCurrQtrAmt',
    comparator: amountComparator,
    editable: false,
    sortable: true,
    isTextColorRed: true,
    minWidth: Styles.Width_180,
    cellEditor: MaxLengthNumericEditor,
    wrapHeaderText: true,
    autoHeaderHeight: true,
    cellRenderer: 'CurrentInvoicedAmtCellRender',
    cellStyle: { textAlign: 'right', 'border-right-color': Styles.BorderColor },
    sortingOrder: ['desc', 'asc'],
    //  exportZeroesTwo: true,
    filter: 'agTextColumnFilter',
    filterParams: {
      defaultOption: 'startsWith',
      suppressAndOrCondition: true,
      buttons: ['reset'],
      refreshValuesOnOpen: true,
    },
  },
  {
    headerName: 'Accumulated Total',
    field: 'accumulatedTotal',
    comparator: amountComparator,
    editable: false,
    sortable: true,
    suppressMenu: false,
    resizable: false,
    isTextColorRed: true,
    minWidth: Styles.Width_180,
    cellEditor: MaxLengthNumericEditor,
    wrapHeaderText: true,
    autoHeaderHeight: true,
    cellRenderer: 'AccumulatedTotalCellRender',
    cellStyle: { textAlign: 'right', 'border-right-color': Styles.BorderColor },
    sortingOrder: ['desc', 'asc'],
    //  exportZeroesTwo: true,
    filter: 'agTextColumnFilter',
    filterParams: {
      defaultOption: 'startsWith',
      suppressAndOrCondition: true,
      buttons: ['reset'],
      refreshValuesOnOpen: true,
    },
  },
];
export const invoiceTableHead = [];
